import React, { useState, useEffect, useRef } from 'react';
import { HTTPService } from '../../../core/util/httpManager';
import { emailSource } from '../../semantic_search.types';

interface EmailPreviewProps {
    source: emailSource;
}

interface EmailData {
    html: string;
    from: string;
    sentOn: string;
    subject: string;
    recipients: string[];
    cc: string[];
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ source }) => {
    const [emailData, setEmailData] = useState<EmailData | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const iFrameRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const fetchEmailData = async () => {
            setIsLoading(true);
            try {
                const documentGuid = source.SourceId.substring(6);
                if (!documentGuid) {
                    console.error("Email source is missing IsGuid.");
                    setEmailData(null);
                    return;
                }
                const result = await HTTPService.get<EmailData>(`Document/GetMsgOrEmlPreview?documentguid=${documentGuid}`);
                setEmailData(result);

            } catch (error) {
                console.error("Failed to fetch email details", error);
                setEmailData(null);
            } finally {
                setIsLoading(false);
            }
        };

        fetchEmailData();
    }, [source.SourceId]);

    useEffect(() => {
        if (emailData?.html && iFrameRef.current) {
            const iFrameDoc = iFrameRef.current.contentWindow.document;
            iFrameDoc.open();
            iFrameDoc.write(emailData.html);
            iFrameDoc.close();
        }
    }, [emailData]);

    if (isLoading) {
        return <div>Loading email...</div>;
    }

    if (!emailData) {
        return <div>Could not load email preview.</div>;
    }

    const sentOn = emailData.sentOn ? kendo.toString(kendo.parseDate(emailData.sentOn), 'G') : 'N/A';
    
    return (
        <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", padding: "8px", boxSizing: 'border-box' }}>
            <div style={{ flexShrink: 0, borderBottom: '1px solid #ddd', paddingBottom: '8px', marginBottom: '8px' }}>
                <div style={{ fontWeight: 'bold' }}>{emailData.subject}</div>
                <div><strong>From:</strong> {emailData.from}</div>
                <div><strong>To:</strong> {emailData.recipients.join(', ')}</div>
                {emailData.cc && emailData.cc.length > 0 && <div><strong>CC:</strong> {emailData.cc.join(', ')}</div>}
                <div><strong>Sent:</strong> {sentOn}</div>
            </div>
            <iframe
                ref={iFrameRef}
                style={{ flex: 1, height: "100%", width: "100%", border: 'none' }}
                title="Email Content"
            />
        </div>
    );
};